<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent" v-if="component"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <h3 v-if="category.name">{{ category.name }}</h3>
          <h3 v-else>{{ _('New Category') }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('General category information') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 leftcol">
                <div class="form-group languageversioned">
                  <label for="name">{{ _('Name') }}</label>
                  <input type="text" class="form-control" id="productTitle" :placeholder="_('Enter category name')" name="name" v-model="category.name" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 leftcol">
                <div class="form-group languageversioned">
                  <label for="marketingname">{{ _('Direct URL') }}</label>
                  <input type="text" class="form-control" id="productDirectUrl" :placeholder="_('Enter a direct URL path fragment that can be used to access this category')" name="canonical" v-model="category.canonical" />
                </div>
              </div>
              <div class="col-sm-6">
                <label class="hidden-xs"></label>
                <p>
                {{ _('You can set a custom URL path fragment that is used in all the links to this item in the Storefront. It may also be displayed in the browser\'s location bar. If you don\'t specify one, it will be automatically generated for you.') }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group languageversioned">
                  <label for="description">{{ _('Short description') }}</label>
                  <editor v-model="category.description" />
                </div>
              </div>
            </div>
            <div class="row" v-if="category && category.channeldata">
              <div class="col-xs-12">
                <div class="form-group languageversioned">
                  <label for="channel_description">{{ _('General description') }}</label>
                  <editor v-model="category.channeldata.description" :embeds-enabled="true" :columns-enabled="true" :extra-images="category.sharedFile || []" :queue-upload="queueDescriptionImage" @add-extra-image="addPastedExtraImage" />
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('details')" class="tab-pane active" id="details" v-if="category && category.channeldata && isTabActive('details')" key="details">
            <div class="row">
              <div class="col-xs-12">
                <div class="panel-group" id="detailsAccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-default reservablePanel" v-if="category.ma_propertyid">
                    <div class="panel-heading" role="tab" id="headingTwo">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          {{ _('General') }}
                        </a>
                      </h4>
                    </div>
                    <div id="collapseTwo" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingTwo">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label for="streetaddress">{{ _('Street Address') }}</label>
                              <input type="text" class="form-control" id="streetAddress" :placeholder="_('Enter the street address')" name="channel_streetaddress" v-model="category.channeldata.streetaddress" />
                            </div>
                            <div class="form-group">
                              <label for="postcode">{{ _('Postal code') }}</label>
                              <input type="text" class="form-control" id="postCode" :placeholder="_('Enter the postal code')" name="channel_postcode" v-model="category.channeldata.postcode" />
                            </div>
                            <div class="form-group">
                              <label for="postarea">{{ _('Postal address') }}</label>
                              <input type="text" class="form-control" id="postArea" :placeholder="_('Enter the postal address')" name="channel_postarea" v-model="category.channeldata.postarea" />
                            </div>
                            <div class="form-group">
                              <label for="municipality">{{ _('Municipality') }}</label>
                              <input type="text" class="form-control" id="municipality" :placeholder="_('Enter the municipality')" name="channel_municipality" v-model="category.channeldata.municipality" />
                            </div>
                            <div class="form-group">
                              <label for="country">{{ _('Country') }}</label>
                              <select class="form-control" name="channel_country" id="country" v-model="category.channeldata.country">
                                <option v-for="(country, id) in countries" :value="id" v-if="id == 'FI'">{{ country }}</option>
                                <option v-for="(country, id) in countries" :value="id" v-if="isPriorityCountry(id)">{{ country }}</option>
                                <option class="select-separator" disabled="disabled">────────────</option>
                                <option v-for="(country, id) in countries" :value="id">{{ country }}</option>
                              </select>
                            </div>
                            <div class="form-group">
                              <label for="apartmenttype">{{ _('Holiday apartment type') }}</label>
                              <select class="form-control" id="holidayApartmentType" name="channel_apartmenttype" v-model="category.channeldata.apartmenttype">
                                <option value="">-</option>
                                <option value="cottage">{{ _('Cottage') }}</option>
                                <option value="villa">{{ _('Villa') }}</option>
                                <option value="cabin">{{ _('Cabin') }}</option>
                                <option value="chalet">{{ _('Chalet') }}</option>
                                <option value="bnb">{{ _('Bed and breakfast') }}</option>
                                <option value="lapphut">{{ _('Lapp hut') }}</option>
                                <option value="castle">{{ _('Castle') }}</option>
                                <option value="farm">{{ _('Farm') }}</option>
                                <option value="farmhouse">{{ _('Farmhouse') }}</option>
                                <option value="house">{{ _('House') }}</option>
                                <option value="apartment">{{ _('Apartment') }}</option>
                                <option value="room">{{ _('Room') }}</option>
                                <option value="granary">{{ _('Granary') }}</option>
                                <option value="campingsite">{{ _('Camping site') }}</option>
                                <option value="other">{{ _('Other') }}</option>
                              </select>
                            </div>
                            <div class="form-group">
                              <label for="numberofbedrooms">{{ _('Number of bedrooms') }}</label>
                              <input type="text" class="form-control" id="numberOfBedRooms" :placeholder="_('Enter the number of bedrooms')" name="channel_numberofbedrooms" v-model="category.channeldata.numberofbedrooms" />
                            </div>
                            <div class="form-group">
                              <label for="numberofbeds">{{ _('Number of beds') }}</label>
                              <input type="text" class="form-control" id="numberOfBeds" :placeholder="_('Enter the number of beds')" name="channel_numberofbeds" v-model="category.channeldata.numberofbeds" />
                            </div>
                            <div class="form-group">
                              <label for="extrabeds">{{ _('Extra beds') }}</label>
                              <input type="text" class="form-control" id="extraBeds" :placeholder="_('Enter the number of extra beds')" name="channel_extrabeds" v-model="category.channeldata.extrabeds" />
                            </div>
                            <div class="form-group">
                              <label for="livingarea">{{ _('Living area') }}</label>
                              <input type="text" class="form-control" id="livingArea" :placeholder="_('Enter the living area in square meters')" name="channel_livingarea" v-model="category.channeldata.livingarea" />
                            </div>
                          </div>
                          <div class="col-sm-6 panel-column">
                            <div class="form-group">
                              <label for="constructionyear">{{ _('Construction year') }}</label>
                              <input type="text" class="form-control" id="constructionYear" :placeholder="_('Enter the construction year')" name="channel_constructionyear" v-model="category.channeldata.constructionyear" />
                            </div>
                            <div class="form-group">
                              <label for="renovationyear">{{ _('Renovation year') }}</label>
                              <input type="text" class="form-control" id="renovationYear" :placeholder="_('Enter the renovation year')" name="channel_renovationyear" v-model="category.channeldata.renovationyear" />
                            </div>
                            <div class="form-group">
                              <label for="malorating">{{ _('MaLo rating') }}</label>
                              <select class="form-control" id="maloRating" name="channel_malorating" v-model="category.channeldata.malorating">
                                <option value="">-</option>
                                <option value="5">5</option>
                                <option value="4">4</option>
                                <option value="3">3</option>
                                <option value="2">2</option>
                                <option value="1">1</option>
                              </select>
                            </div>
                            <div class="form-group languageversioned">
                              <label for="furtherinformation">{{ _('Further information') }}</label>
                              <textarea id="furtherInformation" class="form-control" name="channel_furtherinformation" rows="10" wrap="virtual" v-model="category.channeldata.furtherinformation"></textarea>
                            </div>
                            <div class="form-group">
                              <label for="infourl">{{ _('Website') }}</label>
                              <input type="text" class="form-control" id="infoUrl" :placeholder="_('Enter the website URL')" name="channel_website" v-model="category.channeldata.website" />
                            </div>
                            <div class="form-group">
                              <label for="channel_latitude">{{ _('Latitude') }}</label>
                              <input type="text" class="form-control" id="latitude" :placeholder="_('Enter the latitude')" name="channel_latitude" v-model="category.channeldata.latitude" />
                            </div>
                            <div class="form-group">
                              <label for="channel_longitude">{{ _('Longitude') }}</label>
                              <input type="text" class="form-control" id="longitude" :placeholder="_('Enter the longitude')" name="channel_longitude" v-model="category.channeldata.longitude" />
                            </div>
                            <div class="form-group">
                              <button type="button" class="btn btn-success" id="pickLocationButton" v-on:click="pickLocation"><i class="fa fa-fw fa-map-marker"></i> {{ _('Pick location from the map') }}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default" v-else>
                    <div class="panel-heading" role="tab" id="headingTwo">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          {{ _('General') }}
                        </a>
                      </h4>
                    </div>
                    <div id="collapseTwo" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingTwo">
                      <div class="panel-body">
                        <div class="form-group">
                          <label for="channel_latitude">{{ _('Latitude') }}</label>
                          <input type="text" class="form-control" id="latitude" :placeholder="_('Enter the latitude')" name="channel_latitude" v-model="category.channeldata.latitude" />
                        </div>
                        <div class="form-group">
                          <label for="channel_longitude">{{ _('Longitude') }}</label>
                          <input type="text" class="form-control" id="longitude" :placeholder="_('Enter the longitude')" name="channel_longitude" v-model="category.channeldata.longitude" />
                        </div>
                        <div class="form-group">
                          <button type="button" class="btn btn-success" id="pickLocationButton" v-on:click="pickLocation"><i class="fa fa-fw fa-map-marker"></i> {{ _('Pick location from the map') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="headingSix">
                      <h4 class="panel-title">
                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#detailsAccordion" href="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                          {{ _('SEO') }}
                        </a>
                      </h4>
                    </div>
                    <div id="collapseSix" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingSix">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group languageversioned">
                              <label for="categoryPagetitle">{{ _('Page title') }}</label>
                              <input type="text" class="form-control" id="categoryPagetitle" v-model="category.pagetitle" />
                            </div>
                            <div class="form-group">
                              <label for="categorySeoTags">{{ _('SEO Tags') }}</label>
                              <div class="input-group flex-input-group">
                                <v-select id="categorySeoTags" :options="allSelectableSeoTags" v-model="seoTagToAdd" v-on:option:selected="addSeoTagDialog" :taggable="true" label="title" keys="['title']" :placeholder="_('Type to search or add tags')">
                                  <template v-slot:no-options="{ searching }">
                                    <template v-if="searching">
                                      {{ _('No results found.') }}
                                    </template>
                                    <template v-else>{{ _('Type to search or add tags') }}</template>
                                  </template>
                                  <template v-slot:option="option"><i v-if="option.locale && option.locale !== 'default'">({{ getVersionName(option.locale) }}) </i>{{ option.title }}</template>
                                </v-select>
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info tagsmanagement" v-on:click="manageTagsDialog('seo')"><i class="fa fa-fw fa-tags"></i> {{ _('Manage tags') }}</button>
                                </span>
                              </div>
                            </div>
                            <div class="form-group" v-if="versionlessSeoTags.length">
                              <h5>{{ _('Tags used in any language version') }}:</h5>
                              <div id="tagsList">
                                <span v-for="tag in versionlessSeoTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                              </div>
                            </div>
                            <div class="form-group" v-if="currentVersionSeoTags.length">
                              <h5>{{ _('Tags used only in the selected language version') }}:</h5>
                              <div id="tagsList">
                                <span v-for="tag in currentVersionSeoTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                              </div>
                            </div>
                            <div class="form-group" v-if="otherVersionSeoTags.length">
                              <h5>{{ _('Tags used in other language versions') }}:</h5>
                              <div id="tagsList">
                                <span v-for="tag in otherVersionSeoTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                              </div>
                            </div>
                            <p>{{ _('SEO Tags are used in Johku Storefront in the metadata that is shown to search engines.') }}</p>
                            <div class="form-group languageversioned">
                              <label>{{ _('Published') }}</label>
                              <DatePicker v-model="seoDatePublished" :shortLocale="shortLocale" :staticInput="true" :time-picker="true" :time-picker-inline="true" :clearable="true" :placeholder="_('Select date')" field="datepublished"></DatePicker>
                            </div>
                            <div class="form-group languageversioned">
                              <label>{{ _('Last modified') }}</label>
                              <DatePicker v-model="seoDateModified" :shortLocale="shortLocale" :staticInput="true" :time-picker="true" :time-picker-inline="true" :clearable="true" :placeholder="_('Select date')" field="datemodified"></DatePicker>
                            </div>
                            <div class="form-group languageversioned">
                              <label for="categoryDatedisplay">{{ _('Date display') }}</label>
                              <select class="form-control" id="categoryDatedisplay" v-model="seoDateDisplay">
                                <option value="">{{ _('Hidden') }}</option>
                                <option value="published">{{ _('Published date only') }}</option>
                                <option value="modified">{{ _('Last modified date only') }}</option>
                                <option value="both">{{ _('Both published & modified') }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6" style="min-height: 150px">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('products')" class="tab-pane active" id="products" v-if="isTabActive('products')" key="products">
            <div class="row">
              <div class="col-lg-6 leftcol" v-if="!category.min_count">
                <div class="form-group">
                  <h3>{{ _('Products in this category') }}</h3>
                </div>
                <table class="table table-striped sortable">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                      <th>&nbsp;</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody class="resourcerows" id="linkedProductsList" v-if="!linkedProducts || !linkedProducts.length">
                  </tbody>
                  <draggable v-else v-model="linkedProducts" tag="tbody" draggable=".linkedproduct" :delay="100" :delayOnTouchOnly="true" v-on:change="linkedProductsReordered">
                    <tr class="linkedproduct" v-for="product in linkedProducts" :key="linkedProductKey(product)">
                      <td class="sortable">{{ product.name }}</td>
                      <td>{{ (product.shopid != shopId ? product.shopid : '') }}</td>
                      <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeLinkedProduct(product)"><i class="fa fa-fw fa-close"></i></a></td>
                    </tr>
                  </draggable>
                </table>
                <div class="form-inline">
                  <button type="button" class="btn btn-info" id="addLinkedProduct" v-on:click="selectLinkedProduct"><i class="fa fa-fw fa-link"></i> {{ _('Add product') }}</button>
                </div>
              </div>
              <div class="col-lg-6 rightcol">
                <div class="form-group">
                  <h3>{{ _('Storefront view') }}</h3>
                </div>
                <div class="form-group">
                  <ProductListViewSelector id="categoryView" v-model="category.view" />
                </div>
                <div class="form-group">
                  <label for="productListColumnCount">{{ _('Product list column count') }}</label>
                  <select class="form-control" id="productListColumnCount" v-model="category.productlistcolumncount">
                    <option :value="null">{{ _('Default') }}</option>
                    <option :value="2">2</option>
                    <option :value="3">3</option>
                    <option :value="4">4</option>
                  </select>
                </div>
                <div class="form-group languageversioned">
                  <label for="buttontext">{{ _('Action button text') }}</label>
                  <input type="text" class="form-control" id="buttonText" name="buttontext" :placeholder="_('Show all')" v-model="category.buttontext" />
                  <p class="help-block" v-if="isDateSortedViewSelected">{{ _('Date-sorted lists show the newest products first. The action button after the list shows the rest.') }}</p>
                </div>
                <div class="form-group languageversioned" v-if="isSearchPlaceholderFieldVisible">
                  <label for="searchPlaceholder">{{ _('Search placeholder') }}</label>
                  <input type="text" class="form-control" id="searchPlaceholder" :placeholder="_('Enter a placeholder text to be displayed in the search field')" name="searchplaceholder" v-model="category.searchplaceholder" />
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('links')" class="tab-pane active" id="links" v-if="category.ma_propertyid && isTabActive('links')" key="links">
            <div class="row">
              <div class="col-lg-12 leftcol">
                <div class="form-group">
                  <h3>{{ _('MyAllocator') }}</h3>
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                      <th>{{ _('MyAllocator') }}</th>
                    </tr>
                  </thead>
                  <tbody class="resourcerows" id="myAllocatorProductsList">
                    <tr v-for="product in localProducts">
                      <td style="line-height: 34px">{{ product.name }}</td>
                      <td>
                        <select class="form-control" v-model="myAllocatorLinks[product.source_id]">
                          <option value="0">{{ _('Don\'t link') }}</option>
                          <option value="1">{{ _('Create a new room in MyAllocator') }}</option>
                          <optgroup :label="_('Associate with an existing room in MyAllocator')" v-if="myAllocatorRooms.length">
                            <option v-for="room in myAllocatorRooms" :value="room.id">{{ room.name }} ({{ room.id }})</option>
                          </optgroup>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group">
                  <button class="btn btn-danger" type="button" v-on:click="unlinkMyAllocator"><i class="fa fa-fw fa-unlink"></i> {{ _('Unlink category from MyAllocator property') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('images')" class="tab-pane active" id="images" v-if="isTabActive('images')" key="images">
            <div class="row">
              <div class="col-lg-6 leftcol">
                <h3>{{ _('Main image') }}</h3>
                <image-slot :file-id="category.file_id" :ext="category.file_ext" :owner-key="uploadOwnerKey" upload-slot="main" :empty-text="_('This category has no main image.')" input-id="mainImage" image-element-id="productImage" remove-button-id="removeImageButton" v-on:upload="queueUploads($event, 'main')" v-on:library="chooseFromLibrary('main')" v-on:remove="removeImage('main')" v-on:details="editCaption('main')" />
                <h3>{{ _('Mobile main image') }}</h3>
                <span v-if="!parseInt(category.file_id)">
                  <p>{{ _('This category has no main image.') }}</p>
                </span>
                <image-slot v-else :file-id="category.mobileimage_id" :ext="category.mobileimage_ext" :owner-key="uploadOwnerKey" upload-slot="mobile" :empty-text="_('This category has no mobile main image.')" input-id="mobileImage" image-element-id="productMobileImage" remove-button-id="removeMobileImageButton" v-on:upload="queueUploads($event, 'mobile')" v-on:library="chooseFromLibrary('mobile')" v-on:remove="removeImage('mobile')" v-on:details="editCaption('mobile')" />
              </div>
              <div class="col-lg-6 rightcol">
                <h3>{{ _('Additional images') }}</h3>
                <image-gallery id="additionalImages" v-if="category" v-model:images="category.sharedFile" :owner-key="uploadOwnerKey" upload-slot="gallery" :empty-text="_('This category has no additional images.')" input-id="additionalImage" v-on:upload="queueUploads($event, 'gallery')" v-on:library="chooseFromLibrary('gallery', { multiple: true, max: $event })" v-on:remove="removeImage($event)" v-on:details="editCaption($event)">
                  <template #badge="{ image }">
                    <span :class="isEmbeddedExtraImage(image) ? 'label label-info extra-image-badge' : 'label label-default extra-image-badge'">{{ isEmbeddedExtraImage(image) ? _('In description') : _('Gallery') }}</span>
                  </template>
                </image-gallery>
                <div class="row">
                  <div class="col-xs-12">
                    <hr/>
                    <p>{{ _('The main image is used in the embeddable widget and in Johku storefront. This image is also used in channels that enable setting a main image. The category may have a maximum of twenty images in addition to the main image.') }}</p>
                    <p class="text-muted">{{ _('Images marked In description are shown in the category description and omitted from the storefront slideshow.') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('saleschannels')" class="tab-pane active" id="saleschannels" v-if="isTabActive('saleschannels')" key="saleschannels">
            <div class="row">
              <div class="col-xs-12">
                <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="headingOne">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          {{ _('Enabled Sales Channels for this Category') }}
                        </a>
                      </h4>
                    </div>
                    <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                      <div class="panel-body">
                        <div class="publishing-status-row" style="display: flex; align-items: center; flex-wrap: wrap; gap: 10px; margin-bottom: 15px;">
                          <div class="btn-group" role="group">
                            <button type="button" :class="['btn publishing-mode-btn', publishingMode === 'none' ? 'btn-default active' : 'btn-default']" :aria-pressed="publishingMode === 'none'" v-on:click="setPublishingStatus('none')">
                              <i class="fa fa-fw fa-eye-slash"></i> {{ _('Not published') }}
                              <input type="checkbox" tabindex="-1" aria-hidden="true" :checked="publishingMode === 'none'" />
                            </button>
                            <button type="button" :class="['btn publishing-mode-btn', publishingMode === 'all' ? 'btn-success active' : 'btn-default']" :aria-pressed="publishingMode === 'all'" v-on:click="setPublishingStatus('all')">
                              <i class="fa fa-fw fa-globe"></i> {{ _('Published to all') }}
                              <input type="checkbox" tabindex="-1" aria-hidden="true" :checked="publishingMode === 'all'" />
                            </button>
                            <button type="button" :class="['btn publishing-mode-btn', publishingMode === 'selected' ? 'btn-primary active' : 'btn-default']" :aria-pressed="publishingMode === 'selected'" v-on:click="setPublishingStatus('selected')">
                              <i class="fa fa-fw fa-users"></i> {{ _('Published to selected people') }}
                              <input type="checkbox" tabindex="-1" aria-hidden="true" :checked="publishingMode === 'selected'" />
                            </button>
                          </div>
                        </div>
                        <div v-if="publishingMode !== 'none'">
                          <div class="well well-sm" style="margin-bottom: 8px">
                            <p style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em; margin: 0 0 6px; color: #888">{{ _('Visible in') }}</p>
                            <div class="checkbox" style="margin-top: 0">
                              <label>
                                <input type="checkbox" class="globalCatalogCheckbox" :checked="enabledVersionsList.length > 0 && enabledVersionsList.length === storefrontversions.length" v-on:input="versionsChanged('global', $event.target.checked)" />
                                <strong>{{ _('All language versions') }}</strong>
                              </label>
                            </div>
                            <template v-if="storefrontversions && storefrontversions.length">
                              <hr style="margin: 6px 0">
                              <div class="checkbox" style="margin-top: 4px" v-for="version in storefrontversions" :key="version">
                                <label>
                                  <input type="checkbox" class="versionCatalogCheckbox" :checked="enabledVersionsList.includes(version)" v-on:input="versionsChanged(version, $event.target.checked)" />
                                  {{ getVersionName(version) }}
                                </label>
                              </div>
                            </template>
                          </div>
                          <p v-if="!publishingModeIsValid" class="text-danger" style="margin-top: -4px; margin-bottom: 8px"><i class="fa fa-fw fa-warning"></i> {{ _('At least one language must be selected.') }}</p>
                          <div style="margin-top: 15px">
                            <small style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em; color: #888">{{ _('Storefront') }}</small>
                            <h4 style="margin-top: 2px">{{ _('Collections') }}</h4>
                            <div v-if="collectionsForCategory.length">
                              <div class="checkbox" v-for="col in collectionsForCategory" :key="col.id">
                                <label>
                                  <input type="checkbox" :value="col.id" v-model="selectedCollectionIds" />
                                  {{ col.name }}
                                </label>
                              </div>
                              <p v-if="publishingMode === 'selected' && selectedCollectionIds.length === 0" class="text-danger" style="margin-top: 4px; margin-bottom: 0"><i class="fa fa-fw fa-warning"></i> {{ _('At least one collection must be selected.') }}</p>
                            </div>
                            <p v-else class="text-muted"><small>{{ _('No collections available') }}</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="headingAdditional">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseAdditional" aria-expanded="true" aria-controls="collapseAdditional">
                          {{ _('Additional settings') }}
                        </a>
                      </h4>
                    </div>
                    <div id="collapseAdditional" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingAdditional">
                      <div class="panel-body">
                        <h4>{{ _('Widgets') }}</h4>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" class="widgetsCheckBox" name="enable_widgets" v-model="isEnabledInWidgets" :true-value="1" :false-value="0"/>
                            {{ _('Always allow products in this category to be visible in widgets') }}
                          </label>
                        </div>
                        <h4>{{ _('Full-text search') }}</h4>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" class="searchCheckBox" name="enable_search" v-model="isEnabledInSearch" :true-value="1" :false-value="0"/>
                            {{ _('Always allow products in this category to be indexed in the full-text search') }}
                          </label>
                        </div>
                        <h4>{{ _('Cash register') }}</h4>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" class="posCheckbox" name="enable_pos" v-model="isEnabledInPos" :true-value="1" :false-value="0"/>
                            {{ _('Display this category in Johku POS components') }}
                          </label>
                        </div>
                        <div v-if="isMyAllocatorEnabled" style="margin-top: 10px">
                          <h4 v-if="category.ma_propertyid">{{ _('MyAllocator') }} (Property ID {{ category.ma_propertyid }})</h4>
                          <h4 v-else>{{ _('MyAllocator') }}</h4>
                          <div v-if="!category.ma_propertyid">
                            <div class="form-group">
                              <label>
                                <input type="checkbox" id="enableMyallocator" v-model="enableMyallocator" :true-value="1" :false-value="0"/>
                                {{ _('Include in MyAllocator') }}
                              </label>
                            </div>
                            <div class="form-group" id="propertySelector" v-if="enableMyallocator">
                              <label>
                                <input type="radio" id="newProperty" name="ignore_propertytype" checked="checked" value="newProperty" v-model="myallocatorPropertyType">
                                {{ _('Create a new property in MyAllocator') }}
                              </label>
                              <br />
                              <label>
                                <input type="radio" id="existingProperty" name="ignore_propertytype" value="existingProperty" v-model="myallocatorPropertyType">
                                {{ _('Use an existing property in MyAllocator') }}
                              </label>
                            </div>
                            <div class="form-group" id="propertyIdSelectorContainer" v-if="myallocatorPropertyType === 'existingProperty'">
                              <select class="form-control" id="propertyIdSelector" v-model="category.ma_propertyid">
                                <option value="" v-if="maProperties.length === 0">{{ _('Loading properties from MyAllocator, please wait...') }}</option>
                                <option :value="property.id" v-else v-for="property in maProperties">{{ property.name }}</option>
                              </select>
                            </div>
                          </div>
                          <iframe v-else width="100%" style="border-width: 0" :src="myallocatorIframeUrl"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading" role="tab" id="headingThree">
                      <h4 class="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                          {{ _('Shops Using Your Sales Channel') }}
                        </a>
                      </h4>
                    </div>
                    <div id="collapseThree" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingThree">
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-sm-12 panel-column">
                            <h4>{{ _('My Sales Channel') }}</h4>
                            <div class="checkbox">
                              <label>
                                <input type="checkbox" class="publicCheckbox" name="public" v-model="isPublic" :true-value="1" :false-value="0"/>
                                {{ _('Make this category available to other merchants') }}
                              </label>
                            </div>
                            <h4>{{ _('Template') }}</h4>
                            <div class="checkbox">
                              <label>
                                <input type="checkbox" name="istemplate" v-model="isTemplate" :true-value="1" :false-value="0"/>
                                {{ _('This category and its products can be used as templates in shops using your sales channel') }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <div class="button-col">
          <button class="btn btn-danger" v-on:click="remove(_('Are you sure you want to delete the category? Deletion can\'t be undone.'))" type="button" :disabled="!isRemoveButtonEnabled"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete category') }}</span></button>
          <button class="btn btn-info" v-on:click="translateDialog" type="button" v-if="isTranslateButtonVisible" :disabled="!isTranslateButtonEnabled"><i class="fa fa-fw fa-language"></i><span class="hidden-xs"> {{ _('Translate') }}</span></button>
        </div>
        <div class="button-col">
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from 'axios'
import { DateTime } from 'luxon'
import changewatcher from '~/lib/changewatcher'
import components from '~/lib/components'
import settingshelpers from '~/lib/settingshelpers'
import uploadaware from '~/lib/uploadaware'
import { isDateSortedView } from '~/lib/productListViews'
import { ProductSelector, FileCaption, LocationSelector, TagsList, TranslationSelector, Editor, ProductListViewSelector } from '#components'
import { mapGetters } from 'vuex'
import { embeddedFileIds, stripEmbeddedImage } from '~/lib/tiptap/johkuEmbedImage'

export default {
  data () {
    return {
      category: {
        channeldata: {}
      },
      saving: false,
      allTags: [],
      seoTagToAdd: '',
      linkedProducts: [],
      addLinkedProducts: [],
      removeLinkedProducts: [],
      myAllocatorLinks: [],
      myAllocatorRooms: [],
      map: null,
      enableMyallocator: false,
      maPropertyType: 'newProperty',
      maProperties: [],
      selectedMaProperty: {},
      publishingMode: 'none',
      collectionsForCategory: [],
      selectedCollectionIds: []
    }
  },
  props: ['selectedCategory'],
  mixins: [changewatcher, components, settingshelpers, uploadaware],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'details', label: this._('Details') },
        { id: 'products', label: this._('Products') },
        { id: 'links', label: this._('Links') },
        { id: 'images', label: this._('Images') },
        { id: 'saleschannels', label: this._('Sales Channels') }
      ])
    },
    ...mapGetters(['countries']),
    storefrontversions () {
      if (!this.settings) {
        return []
      }
      return this.settings.storefrontversions ? this.settings.storefrontversions.split(';') : []
    },
    seoDatePublished: {
      get () {
        return this.sqlDatetimeToDate(this.category && this.category.datepublished)
      },
      set (newValue) {
        if (!this.category) {
          return
        }
        this.category.datepublished = this.dateToSqlDatetime(newValue)
      }
    },
    seoDateModified: {
      get () {
        return this.sqlDatetimeToDate(this.category && this.category.datemodified)
      },
      set (newValue) {
        if (!this.category) {
          return
        }
        this.category.datemodified = this.dateToSqlDatetime(newValue)
      }
    },
    seoDateDisplay: {
      get () {
        const value = this.category && this.category.datedisplay
        if (value === 'published' || value === 'modified' || value === 'both') {
          return value
        }
        return ''
      },
      set (newValue) {
        if (!this.category) {
          return
        }
        this.category.datedisplay = newValue || ''
      }
    },
    embeddedDescriptionFileIds() {
      return embeddedFileIds(this.category?.channeldata?.description)
    },
    isTranslateButtonVisible () {
      return this.isFeatureEnabled('translation')
    },
    isTranslateButtonEnabled() {
      return this.locale !== this.version
    },
    myallocatorPropertyType: {
      get () {
        return this.maPropertyType
      },
      set (newValue) {
        if (newValue === 'existingProperty') {
          this.getMyAllocatorProperties()
        }
        this.maPropertyType = newValue
      }
    },
    isNewCategory () {
      return !this.category || !this.category.id
    },
    isTemplate: {
      get () {
        return parseInt(this.category.istemplate) ? 1 : 0
      },
      set (newValue) {
        this.category.istemplate = newValue ? 1 : 0
      }
    },
    isPublic: {
      get () {
        return parseInt(this.category.public) ? 1 : 0
      },
      set (newValue) {
        this.category.public = newValue ? 1 : 0
      }
    },
    isEnabledInPos: {
      get () {
        return parseInt(this.category.enable_pos) ? 1 : 0
      },
      set (newValue) {
        this.category.enable_pos = newValue ? 1 : 0
      }
    },
    isEnabledInSearch: {
      get () {
        return parseInt(this.category.enable_search) ? 1 : 0
      },
      set (newValue) {
        this.category.enable_search = newValue ? 1 : 0
      }
    },
    isEnabledInWidgets: {
      get () {
        return parseInt(this.category.enable_widgets) ? 1 : 0
      },
      set (newValue) {
        this.category.enable_widgets = newValue ? 1 : 0
      }
    },
    categoryTitle () {
      if (this.isNewCategory) {
        return this._('Create a new category')
      }
      return this.category.name
    },
    seoTags () {
      return this.category && this.category.sharedTag ? this.category.sharedTag.filter(t => t.title && t.title.match && t.title.match(/^seo:::/)) : []
    },
    versionlessSeoTags () {
      return this.seoTags.filter(t => !t.title.match(/:::[a-z]{2}_[A-Z]{2}:::/))
    },
    currentVersionSeoTags () {
      return this.seoTags.filter(t => t.title.match(new RegExp(':::' + this.version +  ':::')))
    },
    otherVersionSeoTags () {
      return this.seoTags.filter(t => t.title.match(/:::[a-z]{2}_[A-Z]{2}:::/) && !t.title.match(new RegExp(':::' + this.version +  ':::')))
    },
    allSeoTags () {
      return this.allTags.filter(t => t.category === 'seo').sort((a, b) => a.title > b.title ? 1 : -1)
    },
    allSelectableSeoTags () {
      const ids = this.seoTags.map(t => t.id)
      return [...this.allSeoTags.filter(t => t.locale === this.version), ...this.allSeoTags.filter(t => t.locale === 'default')].filter(t => !ids.includes(t.id))
    },
    localProducts () {
      return this.linkedProducts.filter(p => p.shopid = this.shopId)
    },
    /*
    myAllocatorLinks () {
      let ret = {}
      for (let i = 0; i < this.localProducts.length; i++) {
        const prod = this.localProducts[i]
        ret[prod.source_id] = 0
        for (let j = 0; j < this.myAllocatorRooms.length; j++) {
          const room = this.myAllocatorRooms[j]
          if (room.product == prod.source_id) {
            ret[prod.source_id] = room.id
          }
        }
      }
      return ret
    },
    */
    myAllocatorLinkedProducts () {
      let ret = []
      for (let id in this.myAllocatorLinks) {
        if (Object.prototype.hasOwnProperty.call(this.myAllocatorLinks, id)) {
          if (parseInt(this.myAllocatorLinks[id]) !== 0) {
            ret.push({ productid: id, roomid: this.myAllocatorLinks[id] })
          }
        }
      }
      return ret
    },
    isMyAllocatorEnabled () {
      if (this.settings.channel_myallocator && this.settings.myallocator_userid && this.settings.myallocator_token) {
        return true
      }
      return false
    },
    myAllocatorUrl () {
      return ''
    },
    publishingStatus () {
      const catalogEmpty = !this.category?.enable_catalog || this.category.enable_catalog === '0'
      const collectionEmpty = !this.category?.enable_collection || this.category.enable_collection === '0'
      if (catalogEmpty && collectionEmpty) return 'none'
      if (!catalogEmpty) return 'all'
      return 'selected'
    },
    publishingModeIsValid () {
      return this.publishingMode === 'none' || this.enabledVersionsList.length > 0
    },
    isSaveButtonEnabled () {
      if (this.saving || this.saved || this.loading || this.locked || this.waitingForUploads) return false
      return this.publishingModeIsValid
    },
    uploadOwner () {
      if (!this.category) {
        return null
      }
      const id = this.category.id
      const label = this._('Category') + (id ? ' ' + id : '') + (this.category.name ? ': ' + this.category.name : '')
      return {
        type: 'category',
        id,
        label,
        open: {
          component: 'CategoryDetails',
          title: label,
          width: 6,
          data: {
            categoryId: id,
            activeTab: 'images'
          }
        }
      }
    },
    enabledVersionsList () {
      const raw = (this.category?.enable_catalog && this.category.enable_catalog !== '0')
        ? this.category.enable_catalog
        : this.category?.enable_collection
      if (!raw || raw === '0') return []
      if (raw === '1') return [...this.storefrontversions]
      return raw.split ? raw.split(';') : []
    },
    versions () {
      const enabledVersions = this.settings.versions.split(';')
      let ret = []
      for (let i = 0; i < this.allVersions.length; i++) {
        if (enabledVersions.includes(this.allVersions[i].identifier)) {
          ret.push(this.allVersions[i])
        }
      }
      return ret
    },
    myallocatorIframeUrl () {
      return `https://inbox.myallocator.com/callbacks/plogin.xt?Vendor=johku&UserId=${this.settings.myallocator_userid}&UserToken=${this.settings.myallocator_token}&PropertyId=${this.category.ma_propertyid}&Destination=channel_direct`
    },
    isSearchPlaceholderFieldVisible () {
      if (!this.category) {
        return false
      }
      switch (this.category.view) {
        case 'availabilitylist':
        case 'availabilitymap':
        case 'availabilityfulltext':
        case 'fulltextsearch':
          return true
      }
      return false
    },
    isDateSortedViewSelected () {
      return !!this.category && isDateSortedView(this.category.view)
    }
  },
  watch: {
    'category.id' (newId) {
      this.publishingMode = newId ? this.publishingStatus : 'none'
      this.selectedCollectionIds = (this.category.sharedCollection || []).map(c => c.id || c)
      if (newId && (this.publishingMode === 'all' || this.publishingMode === 'selected')) {
        this.loadCollectionsForCategory()
      }
    },
    publishingMode (newMode) {
      if (newMode === 'all' || newMode === 'selected') {
        this.loadCollectionsForCategory()
      }
    },
    myAllocatorLinks: {
      deep: true,
      handler (newLinks) {
        for (let i = 0; i < this.myAllocatorRooms.length; i++) {
          for (let prodId in newLinks) {
            if (Object.prototype.hasOwnProperty.call(newLinks, prodId)) {
              if (parseInt(this.myAllocatorRooms[i].id, 10) === parseInt(newLinks[prodId], 10)) {
                this.myAllocatorRooms[i].product = parseInt(prodId, 10)
              }
            }
          }
        }
      }
    }
  },
  methods: {
    sqlDatetimeToDate (value) {
      if (!value) {
        return null
      }
      const raw = String(value).trim()
      let dt = DateTime.fromSQL(raw, { zone: this.timezone })
      if (!dt.isValid) {
        dt = DateTime.fromISO(raw, { setZone: true })
      }
      return dt.isValid ? dt.toJSDate() : null
    },
    dateToSqlDatetime (value) {
      if (!value) {
        return ''
      }
      const date = value instanceof Date ? value : new Date(value)
      if (Number.isNaN(date.getTime())) {
        return ''
      }
      const dt = DateTime.fromJSDate(date).setZone(this.timezone)
      return dt.isValid ? dt.toFormat('yyyy-MM-dd HH:mm:ss') : ''
    },
    isEmbeddedExtraImage(image) {
      return this.embeddedDescriptionFileIds.has(String(image.id))
    },
    addPastedExtraImage(file) {
      if (!file || file.id == null) {
        return
      }
      if (!Array.isArray(this.category.sharedFile)) {
        this.category.sharedFile = []
      }
      if (this.category.sharedFile.findIndex(i => String(i.id) === String(file.id)) === -1) {
        this.category.sharedFile.push({ id: file.id })
      }
    },
    manageTagsDialog (category) {
      this.showModal('tagslist', TagsList, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              category: category,
              modal: true
            }
          },
          className: 'modal-content'
        },
        events: {},
        handlers: {},
        width: 1000
      })
    },
    updateTag (tagId) {
      if (!this.category || !this.category.sharedTag) {
        return
      }
      const newTag = this.allTags.find(tag => tag.id === tagId)
      const tagIndex = this.category.sharedTag.findIndex(tag => tag.id === tagId)
      if (tagIndex !== -1) {
        this.category.sharedTag[tagIndex].title = newTag.value
      }
    },
    async unlinkMyAllocator () {
      try {
        const data = {
          id: this.category.id, 
          ma_propertyid: null
        }
        await axios.patch(this.baseDomain + this.shopId + '/categories/' + this.category.id + '.json?apikey=' + this.apiKey, data)
      } catch(error) {
        this.showError(error)
      }
    },
    async getMyAllocatorProperties () {
      try {
        const { data: properties } = await axios.get(this.baseDomain + this.shopId + '/categories.json?ma_properties=true')
        if (properties) {
          this.maProperties = properties 
        }
      } catch (error) {
        this.showError(error)
      }
    },
    isPriorityCountry (id) {
      return ['SE', 'NO', 'DK', 'EE', 'RU'].indexOf(id) !== -1
    },
    async reloadOnVersionChange () {
      if (!this.category || !this.category.id) {
        return
      }
      await this.loadCategory(this.category.id)
    },
    loadCategory (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/categories/' + id + '.json?apikey=' + this.apiKey + this.versionStr)
        } catch (e) {
          this.showError(e)
          this.loading = false
          reject()
          return
        }
        if (!response.data.channeldata) {
          response.data.channeldata = {}
        }
        this.category = response.data
        const loaders = []
        loaders.push(this.loadSeoTags())
        loaders.push(this.loadLinkedProducts())
        loaders.push(this.loadMyAllocatorRooms())
        await Promise.allSettled(loaders)
        this.storeState()
        this.loading = false
        this.applyPendingUploads()
        resolve(this.category)
      })
    },
    isConditionalTab(tab) {
      if (tab === 'links') {
        if (this.category && !this.category.ma_propertyid) {
          return true
        }
      } 
      if (tab !== 'general') {
        if (!this.category || !this.category.id) {
          return true
        }
      }
      return false
    },
    close () {
      // Commented this out because this won't work with the unsaved changes watcher
      /*
      this.category = {
        channeldata: {}
      }
      */
      if (this.component && this.component.initData && this.component && this.component.initData.modal) {
        this.$emit('close')
      } else {
        this.EventBus.$emit('hideDetailsColumn', {
          shopId: this.shopId
        })
      }
    },
    setPublishingStatus (newStatus) {
      this.publishingMode = newStatus
      const currentVersions = this.enabledVersionsList.length
        ? this.enabledVersionsList
        : [...this.storefrontversions]
      const val = currentVersions.length ? currentVersions.join(';') : '0'
      if (newStatus === 'none') {
        this.category.enable_catalog = '0'
        this.category.enable_collection = '0'
      } else if (newStatus === 'all') {
        this.category.enable_catalog = val
        this.category.enable_collection = val
      } else if (newStatus === 'selected') {
        this.category.enable_catalog = '0'
        this.category.enable_collection = val
      }
    },
    versionsChanged (version, checked) {
      let versions
      if (version === 'global') {
        versions = checked ? [...this.storefrontversions] : []
      } else {
        versions = [...this.enabledVersionsList]
        if (checked) {
          if (!versions.includes(version)) versions.push(version)
        } else {
          versions = versions.filter(v => v !== version)
        }
      }
      const val = versions.length ? versions.join(';') : '0'
      if (this.publishingMode === 'all') {
        this.category.enable_catalog = val
        this.category.enable_collection = val
      } else if (this.publishingMode === 'selected') {
        this.category.enable_catalog = '0'
        this.category.enable_collection = val
      }
    },
    async loadCollectionsForCategory () {
      if (this.collectionsForCategory.length) return
      try {
        const response = await axios.get(
          this.baseDomain + this.shopId + '/collections.json?apikey=' + this.apiKey
        )
        this.collectionsForCategory = response.data || []
      } catch (e) {
        // silently fail; UI shows 'No collections available'
      }
    },
    getSaveData () {
      const data = { 
        ...this.category,
        addlinkedproducts: this.addLinkedProducts,
        removelinkedproducts: this.removeLinkedProducts,
        myallocatorlinkedproducts: this.myAllocatorLinkedProducts,
        sharedCollection: this.selectedCollectionIds,
        product_priorities: this.getLinkedProductPriorities()
      }
      data.version = this.version
      const productListColumns = parseInt(data.productlistcolumncount, 10)
      data.productlistcolumncount = [2, 3, 4].indexOf(productListColumns) !== -1 ? productListColumns : null
      return data
    },
    linkedProductKey (product) {
      return String(product.source_id) + '-' + String(product.shopid)
    },
    getLinkedProductPriorities () {
      return this.linkedProducts
        .filter(p => p.source_id && p.shopid)
        .map(p => ({
          source_id: parseInt(p.source_id, 10),
          shopid: String(p.shopid),
          priority: parseInt(p.priority, 10) || 0
        }))
    },
    linkedProductsReordered (event) {
      if (!event || !event.moved) {
        return
      }
      const count = this.linkedProducts.length
      this.linkedProducts.forEach((product, index) => {
        product.priority = count - index
      })
    },
    hasCustomLinkedProductOrder () {
      return this.linkedProducts.some(p => parseInt(p.priority, 10))
    },
    placeAddedLinkedProductAtEnd () {
      if (!this.hasCustomLinkedProductOrder() || !this.linkedProducts.length) {
        return
      }
      const minPriority = Math.min(...this.linkedProducts.map(p => parseInt(p.priority, 10) || 0))
      this.linkedProducts[this.linkedProducts.length - 1].priority = Math.min(0, minPriority) - 1
    },
    async doRemove () {
      let response
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/categories/' + this.category.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deleting the category failed!'))
      }
      this.showNotification(this._('Category deleted!'))
      this.close()
    },
    async save () {
      await this.awaitUploadsBeforeSave()
      this.saving = true
      if (this.category.enable_catalog && this.category.enable_catalog.split) {
        this.category.enable_catalog = this.category.enable_catalog.split(';')
      }
      if (this.category.enable_collection && this.category.enable_collection.split) {
        this.category.enable_collection = this.category.enable_collection.split(';')
      }
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/categories/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/categories.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        this.applyPendingUploads()
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadCategory(response.data.id)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      this.applyPendingUploads()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.category)
      this.EventBus.$emit('widgetVisibilityUpdate', { shopId: this.shopId })
      if (this.saveShouldClose) {
        this.close()
      }
    },
    setParams (params) {
      this.category = params
    },
    removeTag (tag) {
      this.category.sharedTag = this.category.sharedTag.filter(t => t.id !== tag.id)
    },
    getTagTitle(tag) {
      if (!tag || !tag.title) {
        return ''
      }
      const parts = tag.title.split(':::')
      return parts.pop()
    },
    addSeoTagDialog(tag) {
      if (!tag) {
        return
      }
      if (typeof tag === 'object' && tag.id) {
        return this.addSeoTag(tag)
      }
      this.showDialog({
        title: this._('Add tag'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {
              this.seoTagToAdd = ''
            }
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['type'],
            handler: (data) => {
              if (data.type === 'versionless') {
                this.addSeoTag(tag.title)
              } else {
                this.addSeoTag(tag.title, this.version)
              }
            }
          }
        ],
        fields: [
          {
            title: this._('Tag'),
            type: 'text',
            disabled: true,
            defaultValue: typeof tag === 'object' ? tag.title : tag
          },
          {
            title: this._('Type'),
            type: 'select',
            name: 'type',
            defaultValue: 'versionless',
            options: [{
              value: 'versionless',
              name: this._('Use in any language version')
            },
            {
              value: 'current',
              name: this._('Use only in the current language version')
            }]
          }
        ]
      })
    },
    addSeoTag(tag, version) {
      this.addTag(tag, 'seo', version)
    },
    addTag (tag, type, version) {
      if (!tag) {
        return
      }
      if(typeof tag === 'object') {
        const exists = this.category.sharedTag.filter(t => t.id === tag.id)
        if (!exists.length) {
          this.category.sharedTag.push({ id: tag.id, title: tag.value })
        }
      } else {
        if (version) {
          this.category.sharedTag.push({
            title: type + ':::' + version + ':::' + tag
          })
        } else {
          this.category.sharedTag.push({
            title: type + ':::' + tag
          })
        }
      }
      nextTick(() => {
        this.seoTagToAdd = ''
      })
    },
    loadSeoTags () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/tags.json?type=seo&apikey=' + this.apiKey)
        } catch(e) {
          this.allTags = []
          reject(e)
          return
        }
        this.allTags = response.data
        resolve(response.data)
      })
    },
    loadLinkedProducts () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/categories/' + this.category.id + '/allproducts.json?all=true' + (this.version ? '&version=' + this.version : '') + '&apikey=' + this.apiKey)
        } catch(e) {
          console.log(e)
          this.linkedProducts = []
          this.addLinkedProducts = []
          this.removeLinkedProducts = []
          reject(e)
          return
        }
        this.linkedProducts = (response.data || []).map(p => ({
          ...p,
          source_id: parseInt(p.source_id, 10),
          shopid: String(p.shopid),
          priority: parseInt(p.priority, 10) || 0
        }))
        this.addLinkedProducts = []
        this.removeLinkedProducts = []
        resolve(this.linkedProducts)
      })
    },
    loadMyAllocatorRooms () {
      return new Promise(async (resolve, reject) => {
        if (!this.category.ma_propertyid) {
          resolve()
          return
        }
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/categories/' + this.category.id + '.json?ma_rooms=true&apikey=' + this.apiKey)
        } catch(e) {
          this.myAllocatorRooms = []
          /*
          this.myAllocatorRooms = [{
            id: 355371,
            name: 'Fake MyAllocator room',
            product: 342
          },
          {
            id: 355372,
            name: 'Fake MyAllocator room 2',
            product: 470
          },
          {
            id: 355373,
            name: 'Fake MyAllocator room 3',
            product: 584
          }]
          */
          this.setMyAllocatorLinks()
          resolve([])
          return
        }
        this.myAllocatorRooms = response.data
        this.setMyAllocatorLinks()
        resolve(response.data)
      })
    },
    setMyAllocatorLinks() {
      let ret = {}
      for (let i = 0; i < this.localProducts.length; i++) {
        const prod = this.localProducts[i]
        ret[prod.source_id] = 0
        for (let j = 0; j < this.myAllocatorRooms.length; j++) {
          const room = this.myAllocatorRooms[j]
          if (room.product == prod.source_id) {
            ret[prod.source_id] = room.id
          }
        }
      }
      this.myAllocatorLinks = ret
    },
    removeLinkedProduct (product) {
      if (!product.id) { // This was just added
        this.linkedProducts = this.linkedProducts.filter(p => !(p.id == product.id))
        this.addLinkedProducts = this.addLinkedProducts.filter(p => !(p.source_id === product.source_id && p.shopid === product.shopid))
      } else {
        const ids = this.removeLinkedProducts.map(p => p.id + '-' + p.shopid)
        if (ids.indexOf(product.source_id + '-' + product.shopid) === -1) {
          this.removeLinkedProducts.push({
            source_id: product.source_id,
            name: product.name,
            shopid: product.shopid
          })
          this.linkedProducts = this.linkedProducts.filter(p => p.id !== product.id)
        }
      }
    },
    pickLocation () {
      this.showModal('locationselector', LocationSelector, {
        props: {
          defaultLat: this.category.channeldata.latitude,
          defaultLng: this.category.channeldata.longitude,
          defaultAddress: this.category.channeldata.streetaddress + ' ' + this.category.channeldata.postarea,
          settings: this.settings,
          locale: this.shortLocale
        },
        events: {
          selectLocation: this.locationSelected
        },
        handlers: {},
        width: 800
      })
    },
    locationSelected (data) {
      this.category.channeldata.latitude = data.lat
      this.category.channeldata.longitude = data.lng
    },
    selectLinkedProduct () {
      this.showModal('productselector', ProductSelector, {
        props: {
          selectedProducts: this.linkedProducts.map(p => { return { id: p.source_id + '-' + p.shopid } }),
          useAllProducts: true,
          version: this.version
        },
        events: {
          selectProduct: this.addLinkedProduct
        },
        handlers: {},
        width: 800
      })
    },
    addLinkedProduct (product) {
      // First check if the product has just been removed
      const removedIds = this.removeLinkedProducts.map(p => p.source_id + '-' + p.shopid)
      if (removedIds.indexOf(product.source_id + '-' + product.shopid) !== -1) {
        const prod = this.removeLinkedProducts.find(p => p.source_id === product.source_id && p.shopid === product.shopid)
        if (prod) {
          this.linkedProducts.push(prod)
          this.removeLinkedProducts = this.removeLinkedProducts.filter(p => !(p.source_id === prod.source_id && p.shopid === prod.shopid))
        }
        this.checkMyallocatorLinkage(prod)
      } else {
        const add = {
          source_id: product.source_id,
          name: product.name,
          shopid: product.shopid,
          priority: 0
        }
        this.addLinkedProducts.push(add)
        this.linkedProducts.push(add)
        this.checkMyallocatorLinkage(add)
      }
      this.placeAddedLinkedProductAtEnd()
    },
    async checkMyallocatorLinkage(linkedProduct) {
      // If this category is a MyAllocator property, we should make some additional checks to see what to do by default
      // with the product's ma_roomid link (if any)
      if (this.category.ma_propertyid) {
        let response
        try {
          response = await axios.get(this.baseDomain + linkedProduct.shopid + '/products/' + linkedProduct.source_id + '.json')
        } catch(e) {
          return
        }
        let product = response.data
        if (product.ma_propertyid && product.ma_propertyid != this.category.ma_propertyid) {
          this.showError(this._('Warning! Linking a room from another MyAllocator property is not supported.')) // Shit's fucked yo
        } else if (product.ma_roomid) {
          if (!this.myAllocatorRooms.find(r => r.id == product.ma_roomid)) {
            this.myAllocatorRooms.push({
              id: product.ma_roomid,
              name: this._('MyAllocator room'),
              product: product.id
            })
          }
          this.myAllocatorLinks[product.id] = product.ma_roomid // Preserve link is found
        } else {
          this.myAllocatorLinks[product.id] = 0 // Default: don't link, set to 1 if we should create the link automatically
        }
      }
    },
    removeImage(image) {
      if (image === 'main') { // Remove main image
        this.category.file_id = null
        this.category.file_ext = null
      } if (image === 'mobile') { // Remove mobile main image
        this.category.mobileimage_id = null
        this.category.mobileimage_ext = null
      } else {
        if (this.isEmbeddedExtraImage(image)) {
          if (!confirm(this._('This image is used in the description. Remove it from the description as well?'))) {
            return
          }
          if (this.category.channeldata) {
            this.category.channeldata.description = stripEmbeddedImage(this.category.channeldata.description, image.id)
          }
        }
        this.category.sharedFile = this.category.sharedFile.filter(i => i.id !== image.id)
      }
    },
    // Puts a file uploaded through the upload queue in its place (lib/uploadaware.js)
    applyUploadResult (slot, file) {
      if (!this.category || !file) {
        return
      }
      if (slot === 'main') {
        this.category.file_ext = file.ext
        this.category.file_id = this.category.image_id = file.id
      } else if (slot === 'mobile') {
        this.category.mobileimage_ext = file.ext
        this.category.mobileimage_id = file.id
      } else {
        // 'gallery', and 'embed' for images pasted into the description
        this.addPastedExtraImage(file)
      }
    },
    queueDescriptionImage (file, name) {
      return this.queueUpload(file, 'embed', { name })
    },
    editCaption(source) {
      let data = {}
      if (source === 'main') {
        data.defaultTitle = this.category.file_title
        data.defaultDescription = this.category.file_description
        data.defaultVideo = this.category.file_video
        data.defaultSmartCrop = this.category.file_smartcrop
        data.source = 'main'
      } else if (source === 'mobile') {
        data.defaultTitle = this.category.mobileimage_title
        data.defaultDescription = this.category.mobileimage_description
        data.defaultVideo = this.category.mobileimage_video
        data.defaultSmartCrop = this.category.mobileimage_smartcrop
        data.source = 'mobile'
      } else {
        data.defaultTitle = source.title
        data.defaultDescription = source.description
        data.defaultVideo = source.video
        data.defaultSmartCrop = source.smartcrop
        data.source = source
      }
      data.settings = this.settings
      this.showModal('filecaption', FileCaption, {
        props: data,
        events: {
          save: this.saveCaption
        },
        handlers: {},
        width: 800
      })
    },
    saveCaption (data) {
      if (data.source === 'main') {
        this.category.file_title = data.title
        this.category.file_description = data.description
        this.category.file_video = data.video
        this.category.file_smartcrop = data.smartcrop
      } else if (data.source === 'mobile') {
        this.category.mobileimage_title = data.title
        this.category.mobileimage_description = data.description
        this.category.mobileimage_video = data.video
        this.category.mobileimage_smartcrop = data.smartcrop
      } else {
        for (let i = 0; i < this.category.sharedFile.length; i++) {
          if (this.category.sharedFile[i].id === data.source.id) {
            this.category.sharedFile[i].title = data.title
            this.category.sharedFile[i].description = data.description
            this.category.sharedFile[i].video = data.video
            this.category.sharedFile[i].smartcrop = data.smartcrop
            break
          }
        }
      }
    },
    translateDialog () {
      const $this = this
      this.showModal('translationselector', TranslationSelector, {
        props: {
          title: this._('Select texts to be translated'),
          settings: this.settings,
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              modal: true
            }
          },
          parent: this.category,
          parentType: 'categories',
          className: 'modal-content'
        },
        events: {
          result (data) {
            for (let i = 0; i < data.length; i++) {
              const d = data[i]
              if (d.field.includes('.')) {
                let [type, field] = d.field.split('.')
                if (type === 'channeldata') {
                  $this.category.channeldata[field] = d.text
                }
                if (type.match(/^file\-/)) {
                  let [, nId] = type.split('-')
                  if ($this.category.file_id == nId) {
                    $this.category['file_' + field] = d.text
                  } else {
                    for (let i = 0; i < $this.category.sharedFile.length; i++) {
                      if ($this.category.sharedFile[i].id == nId) {
                        $this.category.sharedFile[i][field] = d.text
                        break
                      }
                    }
                  }
                }
              } else {
                $this.category[d.field] = d.text
              }
            }
          }
        },
        handlers: {},
        width: 1000
      })
    }
  },
  components: {
    Editor,
    TagsList,
    ProductListViewSelector
  },
  created () {
    if (this.component && this.component.initData && !this.loading) {
      this.loadCategory(this.component.initData.categoryId)
    }
  },
  async updated () {
    if (this.component && this.component.initData && !this.loading) {
      if (this.category && this.category.id && parseInt(this.category.id, 10) !== parseInt(this.component.initData.categoryId, 10)) {
        try {
          await this.loadCategory(this.component.initData.categoryId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if (this.selectedCategory) {
      this.loadCategory(this.selectedCategory.id)
    }
    // Not sure what this is for, copied from customerdetails
    if(!this.events) {
      let events = {}
      events['showCategoryDetailsParams'] = (message) => {
        this.setParams(message)
      }
      events['categoryUpdate'] = async (message) => {
        if (message && message.data && this.category && parseInt(message.data.id, 10) === parseInt(this.category.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadCategory(message.data.id)
          }
        }
      }
      events['tagUpdate'] = async (message) => {
        if (message && message.data) {
          await this.loadSeoTags()
          this.updateTag(message.data.id)
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>

<style scoped>
ol#additionalImages {
  list-style-type: none;
  padding: 0;
}
.publishing-mode-btn {
  display: inline-flex;
  align-items: center;
}
.publishing-mode-btn > .fa {
  margin-right: 0.25em;
}
.publishing-mode-btn > input[type="checkbox"] {
  pointer-events: none;
  margin: 0 0 0 6px;
}
tr.linkedproduct {
  cursor: move;
}
</style>